var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomerImagePlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 223.74 210.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #99a7c9;\n      }\n\n      .cls-2 {\n        fill: #f2f5fd;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    className: "cls-2",
    x: 2.87,
    y: 2.82,
    width: 218,
    height: 205,
    rx: 6,
    ry: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_651",
    className: "cls-1",
    d: "M153.59,65.35h-83.44c-3.19,0-5.78,2.58-5.78,5.77,0,0,0,0,0,0v68.39c0,3.19,2.58,5.78,5.77,5.78h83.45c3.19,0,5.78-2.58,5.78-5.77h0v-68.39c0-3.19-2.58-5.78-5.77-5.78,0,0,0,0,0,0M152.39,111.92l-15.59-17.37c-2.14-2.38-5.8-2.57-8.18-.43-.17.16-.34.32-.49.5l-23.19,26.69-9.38-9c-2.25-2.16-5.8-2.15-8.04.02l-16.07,15.63v-55.52h80.93v39.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_652",
    className: "cls-1",
    d: "M102.14,86.17c0,5-4.05,9.05-9.05,9.05s-9.05-4.05-9.05-9.05,4.05-9.05,9.05-9.05c5,0,9.05,4.05,9.05,9.05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerImagePlaceholder);
export default __webpack_public_path__ + "static/media/Customer Image Placeholder.75f826baf5936fdb45fde1392089a271.svg";
export { ForwardRef as ReactComponent };